// @flow
import * as React from 'react'
import { colors } from '@components/shared'

export type PropsType = {
  size?: number,
  color?: string
}

const XIcon = (props: PropsType): React.Node => {
  return (
    <svg
      width={props.size || 30}
      height={props.size || 30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.4278 26.6548C30.2041 27.4333 30.1886 28.679 29.3938 29.4394C29.0041 29.8124 28.4966 30 27.9897 30C27.4667 30 26.9471 29.8033 26.5515 29.4063L15.0001 17.8184L3.44867 29.4063C3.05559 29.8033 2.53322 30 2.01054 30C1.50333 30 0.995813 29.8124 0.606435 29.4394C-0.188711 28.679 -0.204175 27.4333 0.572415 26.6548L12.1919 15L0.572415 3.34571C-0.204175 2.56693 -0.188711 1.32117 0.606435 0.560865C1.40127 -0.200044 2.67208 -0.18459 3.44867 0.594198L15.0001 12.1818L26.5515 0.594198C27.3278 -0.18459 28.6017 -0.200044 29.3938 0.560865C30.1886 1.32117 30.2041 2.56693 29.4278 3.34571L17.8111 15L29.4278 26.6548Z"
        fill={props.color || colors.white}
      />
    </svg>
  )
}

export default XIcon
